import React from 'react';
import { aosStoreIdentifierNames } from 'utility/utility';
import { useAppSelector } from 'store/store';
import { footerTaxoSelector } from 'store/selectors/taxonomySelector';
import { storeIdentifierNameSelector } from 'store/selectors/commonSelector';
import useLogger from 'hooks/useLogger';
import { FooterTaxonomy } from 'types';
import TopMessageCard from '../TopMessageCard/TopMessageCard';
import './TopMessages.scss';

const TopMessages = () => {
  const taxonomy = useAppSelector(footerTaxoSelector);
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const { error } = useLogger();
  const messages: FooterTaxonomy['Footer Message'] = taxonomy['Footer Message'];
  try {
    return aosStoreIdentifierNames.includes(storeIdentifierName) ? null : (
      <div className="top-messages-grid hmf-my-0 hmf-mx-auto hmf-py-xlg-s">
        {messages?.map((message) => (
          <TopMessageCard
            key={message.link}
            icon={message.icon_dropdown}
            topText={message.topText}
            bottomText={message.bottomText}
            ctaText={message.ctaText}
            link={message.link}
          />
        ))}
      </div>
    );
  } catch (e) {
    error('Could not load TopMessages - ', e);
    return null;
  }
};

export default TopMessages;
